import React, { useState, useEffect } from 'react';
import { ToggleLeft } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import Preloader from '../../components/Preloader';
import Permiso from '../../router/Permiso';
import { UsuarioService } from '../../services/UsuarioService';
import SolicitudBajaModal from './SolicitudBajaModal';
import { toast } from 'react-toastify';
import { MotivosBajaService } from '../../services/MotivosBajaService';

const ListadoUsuariosSolicitud = ({ token, refreshTrigger }) => {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [motivos, setMotivos] = useState([]);
    const [jefesDisponibles, setJefesDisponibles] = useState([]);
    const [loadingJefes, setLoadingJefes] = useState(false);
    const [filtroJefe, setFiltroJefe] = useState("");
    const [filtroSupervisor, setFiltroSuppervisor] = useState("");
    const [buscarNombre, setBuscarNombre] = useState("");
    const [buscarDocumento, setBuscarDocumento] = useState("");
    const [showBajaModal, setShowBajaModal] = useState(false);
    const [selectedColaborador, setSelectedColaborador] = useState(null);
    const [supervisoresDisponibles, setSupervisoresDisponibles] = useState([]);
    const [errores, setErrores] = useState({});
    const [loadingSupervisores, setLoadingSupervisores] = useState(false);
    const [bajaForm, setBajaForm] = useState({
        motivo: "",
        comentario: "",
    });

    useEffect(() => {
        fetchUsuarios();
        fetchMotivos();
        cargarJefes();
        cargarSupervisores();
    }, [refreshTrigger, currentPage, buscarNombre, buscarDocumento, filtroJefe, filtroSupervisor]);

    const fetchMotivos = async () => {
        try {
            const data = await MotivosBajaService.getMotivos(token); 
            setMotivos(data);
        } catch (error) {
            console.error('Error al obtener motivos:', error);
        }
    };

    const cargarJefes = async () => {
        setLoadingJefes(true);
        try {
            const data = await UsuarioService.fetchJefes(token);
            setJefesDisponibles(data);
        } catch (error) {
            setJefesDisponibles([]);
            console.log(error);
        } finally {
            setLoadingJefes(false);
        }
    };

    const cargarSupervisores = async () => {
        setLoadingSupervisores(true);
        try {
            const data = await UsuarioService.fetchSupervisores(token);
            setSupervisoresDisponibles(data);
        } catch (error) {
            setSupervisoresDisponibles([]);
            console.log(error);
        } finally {
            setLoadingSupervisores(false);
        }
    };

    const fetchUsuarios = async () => {
         setLoading(true);
        try {
            const { usuarios, totalPaginas, totalRegistros } = await UsuarioService.fetchTeam({
                token,
                page: currentPage,
                limit: 20,
                documento: buscarDocumento,
                nombre: buscarNombre,
                jefe: filtroJefe,
                supervisor: filtroSupervisor
            });
            setUsuarios(usuarios);
            setTotalPages(totalPaginas);
            setTotalRegistros(totalRegistros);
        } catch (err) {
            setError('Error al cargar usuarios');
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const getEstadoClass = (estado) => {
        const estadoValue = estado || "ACTIVO";
        switch (estadoValue.toUpperCase()) {
            case "ACTIVO":
                return "usuarios-estado-activo";
            case "BAJA":
                return "usuarios-estado-baja";
            default:
                return "usuarios-estado-pendiente";
        }
    };

    const handleBajaColaborador = (colaborador) => {
        setSelectedColaborador(colaborador);
        setBajaForm({
            motivo: "",
            comentario: "",
        });
        setShowBajaModal(true);
        setError("");
    };

    const handleFormChange = (e) => {
        setBajaForm({
            ...bajaForm,
            [e.target.name]: e.target.value,
        });
    };

    const handleConfirmarBaja = async () => {
        const nuevosErrores = {};

        if (!bajaForm.motivo) {
            nuevosErrores.motivo = "El motivo es obligatorio";
        }

        if (!bajaForm.comentario) {
            nuevosErrores.comentario = "El comentario es obligatorio";
        }

        if (Object.keys(nuevosErrores).length > 0) {
            setErrores(nuevosErrores);
            return;
        }
        try {
            await UsuarioService.bajaUsuarioSolicitud({
                token,
                id: selectedColaborador.id,
                bajaForm,
            });

            toast.success("Usuario dabo de baja correctamente")
            setShowBajaModal(false);
            fetchUsuarios(); // Recargar la lista
        } catch (err) {
            setError("Error al dar de baja al usuario");
            console.log(err);
        }
    };

    const getNombreCompleto = (usuario) => {
        return `${usuario.nombre || ""} ${usuario.apellidoPaterno || ""} ${usuario.apellidoMaterno || ""
            }`.trim();
    };


    if (loading) return <Preloader />;

    return (
        <div className="usuarios-table-container">
            <div className="usuarios-table-header">
                <h2 className="usuarios-table-title">Listado de usuarios </h2>
            </div>

            <div className="usuarios-filtros">

                <div className="filtro-item">
                    <label htmlFor="filtroJefe">Filtrar por Jefe:</label>
                    <select
                        id="filtroJefe"
                        value={filtroJefe}
                        onChange={(e) => setFiltroJefe(e.target.value)}
                        className="filtro-select"
                    >
                        <option value="">Todos los jefes</option>
                        {jefesDisponibles.map((jefe) => (
                            <option key={jefe.id} value={jefe.id}>
                                {getNombreCompleto(jefe)}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="filtro-item">
                    <label htmlFor="filtroJefe">Filtrar por Supervisor:</label>
                    <select
                        id="filtroJefe"
                        value={filtroSupervisor}
                        onChange={(e) => setFiltroSuppervisor(e.target.value)}
                        className="filtro-select"
                    >
                        <option value="">Todos los supervisores</option>
                        {supervisoresDisponibles.map((supervisor) => (
                            <option key={supervisor.id} value={supervisor.id}>
                                {getNombreCompleto(supervisor)}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="filtro-item">
                    <label htmlFor='buscar-documento'>Buscar por Documento:</label>
                    <input
                        type="text"
                        value={buscarDocumento}
                        onChange={(e) => setBuscarDocumento(e.target.value)}
                        placeholder="Número de Documento"
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor='buscar-nombre'>Buscar por Nombre:</label>
                    <input
                        type="text"
                        value={buscarNombre}
                        onChange={(e) => setBuscarNombre(e.target.value)}
                        placeholder="Nombre, apellido o nombre completo"
                    />
                </div>
                <div className="filtro-grupo">
                    <button
                        onClick={() => {
                            setBuscarNombre("");
                            setBuscarDocumento("");
                            setFiltroSuppervisor("");
                            setFiltroJefe("");
                            fetchUsuarios();
                        }}
                        className="btn-limpiar"
                    >
                        Limpiar Filtros
                    </button>
                </div>

            </div>

            <div className="ventas-table-wrapper">
                <table className="ventas-table">
                    <thead>
                        <tr>
                            <th>Tipo Documento</th>
                            <th>Número</th>
                            <th>Nombres y Apellidos</th>
                            <th>Celular</th>
                            <th>Perfil</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan="6"
                                    style={{ textAlign: "center", padding: "40px" }}
                                >
                                    Cargando...
                                </td>
                            </tr>
                        ) : usuarios.length === 0 ? (
                            <tr>
                                <td
                                    colSpan="6"
                                    style={{ textAlign: "center", padding: "40px" }}
                                >
                                    No hay usuarios registrado
                                </td>
                            </tr>
                        ) : (
                            usuarios.map((usuario) => (
                                <tr key={usuario.id}>
                                    <td>{usuario.tipo_documento || "-"}</td>
                                    <td>{usuario.numero_documento || "-"}</td>
                                    <td>{usuario.nombres || usuario.usuario || "-"}</td>
                                    <td>{usuario.celular || "-"}</td>
                                    <td>{usuario.perfil_nombre || "-"}</td>
                                    <td>
                                        <span
                                            className={`usuarios-estado ${getEstadoClass(
                                                usuario.estado
                                            )}`}
                                        >
                                            {usuario.estado}
                                        </span>
                                    </td>

                                    <td className="ventas-acciones">
                                        {usuario.estado !== "BAJA" && usuario.tipo_baja == null && (
                                            <Permiso permiso="solicitud_baja_user">
                                                <span onClick={() => handleBajaColaborador(usuario)}>
                                                    <ToggleLeft size={22} color="#e74c3c" />
                                                </span>
                                            </Permiso>
                                        )}

                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
                {" "}
                Total de registros: {totalRegistros}{" "}
            </span>
            <div className="pagination">
                <button
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Anterior
                </button>
                <span>
                    Página {currentPage} de {totalPages}
                </span>

                <button
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Siguiente
                </button>
            </div>

            <SolicitudBajaModal
                show={showBajaModal}
                colaborador={selectedColaborador}
                bajaForm={bajaForm}
                handleFormChange={handleFormChange}
                handleConfirmarBaja={handleConfirmarBaja}
                setShowBajaModal={setShowBajaModal}
                error={error}
                errores={errores}
                success={success}
                motivos={motivos}
            />

        </div>
    );
};

export default ListadoUsuariosSolicitud; 